var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92464 11C1.92464 5.98807 5.98765 1.92505 10.9996 1.92505C16.0116 1.92505 20.0746 5.98807 20.0746 11C20.0746 16.012 16.0116 20.075 10.9996 20.075C5.98765 20.075 1.92464 16.012 1.92464 11ZM10.9997 6.50829C11.4553 6.50829 11.8247 6.87766 11.8247 7.33329V11.4583C11.8247 11.9139 11.4553 12.2833 10.9997 12.2833C10.5441 12.2833 10.1747 11.9139 10.1747 11.4583V7.33329C10.1747 6.87766 10.5441 6.50829 10.9997 6.50829ZM11.9163 14.6666C11.9163 15.1729 11.5059 15.5833 10.9996 15.5833C10.4933 15.5833 10.0829 15.1729 10.0829 14.6666C10.0829 14.1604 10.4933 13.75 10.9996 13.75C11.5059 13.75 11.9163 14.1604 11.9163 14.6666Z",
    fill: "#FF4242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.c5068cfe0c662737bc3ad878f4cce365.svg";
export { ForwardRef as ReactComponent };